import {externalApi} from "~/config";

const getContentLang = function() {
  return location.search.replace(/\?/, '').split(',').find(item => item.split('=')[0] == 'lang');
};
let contentLang = getContentLang();

if (contentLang) {
  contentLang = contentLang.split('=')[1];
} else {
  contentLang = 'KO';
}

const GoogleMapsLoader = require('google-maps');
GoogleMapsLoader.LANGUAGE = contentLang;
GoogleMapsLoader.REGION = "KR";
GoogleMapsLoader.VERSION = '3.32';
GoogleMapsLoader.LIBRARIES = ['geometry', 'places'];
GoogleMapsLoader.KEY = externalApi.googleMap.key;

export {GoogleMapsLoader}
